<template>
    <v-list two-line class="py-0 my-0" :color="coColor">
        <v-row>
            <v-list-item class="py-0 my-0">
                <v-col cols="2" xm="2">
                    <v-list-item-avatar class="py-0 my-0">
                        <v-img src="@/assets/images/user1.jpg"></v-img>
                    </v-list-item-avatar>
                </v-col>
                <v-col cols="6" xm="7">
                    <v-list-item-content class="py-0 my-0">
                        <span class="subtitle-2">{{ item.pripersonal.Personal }}</span>
                        <v-list-item-subtitle>{{ item.pripersonal.priservicio.Iniciales }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-col>
                <v-col cols="4" xm="3">
                    <v-list-item-action class="py-0 my-0">
                        <v-spacer></v-spacer>
                        <v-form ref="refNota">
                            <v-progress-circular v-if="!dEdith" @click="fuEdit()" :value="item.nota" :color="item.nota | fiNroColor" :size="50"><h3>{{ item.nota }}</h3></v-progress-circular>
                            <v-text-field ref="refNro" v-else @click:append-outer="fuSave()" @keyup.prevent.enter="fuSave()" @click:prepend="dEdith=false" v-model="item.nota" append-outer-icon="save" prepend-icon="cancel" :loading="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v >= 0 && v <= 100) || 'El campo debe ser menor igual a 100']" :maxlength="3" autocomplete="off" counter dense style="font-size: 20px !important;"></v-text-field>
                        </v-form>
                    </v-list-item-action>
                </v-col>
            </v-list-item>
        </v-row>
    </v-list>
</template>
<script>
import gql from 'graphql-tag';
export default {
    name: 'CPersonaNota',
    props: ['item'],
    filters: {
        fiNroColor: function (value) {
            if (value < 50) return 'red';
            else if (value < 90) return 'amber darken-1';
            else return 'green';
        }
    },
    data: () => ({
        dEdith: false,
        dIsUpdating: false,
        dIsSaved: null,
    }),
    computed: {
        coColor () {
            switch (this.dIsSaved) {
                case null:
                    return 'white';
                    break;
                case true:
                    return 'green lighten-4';
                    break;
                case false:
                    return 'red lighten-5';
                    break;
                default:
                    return 'white';
            }
        }
    },
    methods: {
        fuEdit(){
            this.dEdith=true;
            this.dIsSaved=false;
            //this.$refs.refNro.focus();
        },
        fuSave(){
            if(this.$refs.refNota.validate()){
                this.fuccecapacitacionasistenciaUpdate();
            }
        },
        async fuccecapacitacionasistenciaUpdate () {
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ccecapacitacionasistenciaUpdate($id: ID!, $input: ccecapacitacionasistenciaUpdateInput!){
                        ccecapacitacionasistenciaUpdate(id: $id, input: $input){
                            id
                        }
                    }`,
                    variables: {
                        id: this.item.id,
                        input: {
                            nota: this.item.nota
                        }
                    }
                });
                if(response.data){
                    this.dEdith = false;
                    this.dIsSaved = true;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.dIsUpdating = false;
            }
        },
    }
}
</script>